import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TextAreaQuestion, CheckboxQuestion } from "../../../components/forms";
import NonComplianceReasons from './NonComplianceReasons';
import { BoldText } from "../../../components";

const Container = styled.div`
  padding-left: 2em;
  
  & .controls {
    display: inline-flex;
    justify-content: space-around;
    
    & > * {
      flex: 1; 
      margin: auto;
    }      
  }
    
`;

class CommentsForm extends React.Component {
  state = {
    reasons: []
  };

  addReason = reason => {
    const reasons = [...this.props.form['nonCompliantReasons'].value, reason];
    this.props.onChange('nonCompliantReasons')(reasons);
  }

  removeReason = reason => {
    const reasons = this.props.form['nonCompliantReasons'].value.filter(r => r !== reason);
    this.props.onChange('nonCompliantReasons')(reasons);
  }

  
  reviewerVerificationsSelected = selectedValues => {
    return this.props.onChange('reviewerVerification')(selectedValues);
  }
  render() {
    const { form, onChange } = this.props;

    return (
      <Container>
        <NonComplianceReasons
          selectedReasons={form['nonCompliantReasons'].value}
          onAdd={this.addReason}
          onRemove={this.removeReason}
          disabled={form['nonCompliantReasons'].disabled}
        />
        <TextAreaQuestion
          question="Non-Compliant Case Summary"
          value={form['nonCompliantIndicator'].value}
          onChange={onChange('nonCompliantIndicator')}
          disabled={form['nonCompliantIndicator'].disabled}
        />
        <TextAreaQuestion
          question="Findings/Actions (for DHS MQD)"
          value={form['findingsActions'].value}
          onChange={onChange('findingsActions')}
          disabled={form['findingsActions'].disabled}
        />
        <div style={{paddingBottom: '10px'}}><BoldText>Reviewer Verification</BoldText></div>
        <CheckboxQuestion
          onChange={this.reviewerVerificationsSelected}
          selected={form['reviewerVerification'].value}
          values={[
            "Previous Level II was reviewed and is valid.",
            "There is no significant change warranting a new or sequential Level II, or person’s evaluation found person is not SMI.",
            "Primary Dementia/Alzheimer’s Disease or Related Disorder exempts SMI person from a positive PASRR.",
            "No SMI indicators found.",
            "Psychotropic medication not routinely taken and/or prescribed for psychiatric treatment.",
            "Readmission case, no MDS significant change warranted.",
            "Other (refer to reviewer notes).",
            "Not applicable."
          ]}
          error={!form['reviewerVerification'].hasError ? null : true}
          disabled={form['reviewerVerification'].disabled}
          newLinePerItem={true}
        >
        </CheckboxQuestion>

        <TextAreaQuestion
          question="Reviewer Notes"
          value={form['notes'].value}
          onChange={onChange('notes')}
          disabled={form['notes'].disabled}
          error={!form['notes'].hasError ? null : true}
        />


      </Container>
    )
  }
}

CommentsForm.propTypes = {
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CommentsForm;



// WEBPACK FOOTER //
// ./src/modules/record/components/CommentsForm.js